import { ReactComponent as AlertIcon } from '../../../assets/icons/alert_line.svg';
import classes from './EmptyModalContent.module.scss';

interface EmptyModalContentProps {
  title: string;
}

export const EmptyModalContent = ({ title }: EmptyModalContentProps) => {
  return (
    <div className={classes.emptyModalContent}>
      <AlertIcon />
      <span>{title}</span>
    </div>
  );
};
